var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Telegram_icon",
    "data-name": "Telegram icon",
    transform: "translate(-28 -275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 30,
    height: 30,
    rx: 13,
    transform: "translate(28 305) rotate(-90)",
    fill: "#1e2033",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M18280.344,18383.5a1.254,1.254,0,0,1-.609-.191l-3.746-2.758-1.809,1.742-.023.018a.912.912,0,0,1-.734.35l.266-3.818,6.949-6.277c.09-.08.125-.154.105-.211s-.086-.078-.172-.078a.744.744,0,0,0-.4.139l-8.59,5.4-3.7-1.156c-.367-.117-.586-.3-.594-.508,0-.24.27-.49.758-.684l14.461-5.576a1.1,1.1,0,0,1,.363-.066.68.68,0,0,1,.547.248,1.179,1.179,0,0,1,.137,1l-2.461,11.6C18280.969,18383.219,18280.719,18383.5,18280.344,18383.5Z",
    transform: "translate(-18233.184 -18085.797)",
    fill: "#ebecff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2e6a5125.svg";
export { ForwardRef as ReactComponent };